















export default {
  name: 'BillIcon'
}
